<template>
  <span :class="size">
    <svg xmlns="http://www.w3.org/2000/svg" class="hidden">
      <symbol :id="`${iconId}-${rand}`" v-html="content"></symbol>
    </svg>
    <svg
      :viewBox="viewBox"
      width="100%"
      height="100%"
      aria-hidden="true"
      focusable="false"
    >
      <use :xlink:href="`#${iconId}-${rand}`" :fill="colour" />
    </svg>
    <span v-if="description" class="sr-only">
      {{ description }}
    </span>
  </span>
</template>

<script>
import { ICONS } from "@/data/icons";

export default {
  name: "DoeIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: value => {
        return ["xl", "large", "medium", "small", "mini"].indexOf(value) !== -1;
      }
    },
    icon: {
      type: String,
      default: "waratah",
      required: true,
      validator: value => {
        return Object.keys(ICONS).indexOf(value) !== -1;
      }
    },
    colour: {
      type: String
    },
    description: {
      type: String
    }
  },
  data() {
    return {
      rand: 0
    };
  },
  created() {
    this.rand = Math.floor(Math.random() * 90000) + 10000;
  },
  computed: {
    viewBox() {
      return ICONS[this.icon].viewBox;
    },
    content() {
      return ICONS[this.icon].content;
    },
    iconId() {
      return this.icon;
    }
  }
};
</script>

<style lang="scss" scoped>
span {
  display: inline-block;
  &.mini,
  &.small {
    height: 0.75em;
    vertical-align: baseline;
    width: 0.75em;
  }
  &.medium {
    height: 1em;
    vertical-align: top;
    width: 1em;
  }
  &.large {
    height: 1.25em;
    vertical-align: sub;
    width: 1.25em;
  }
  &.xl {
    height: 5em;
    vertical-align: sub;
    width: 5em;
  }
}
svg {
  @apply fill-current;
}
</style>
